<template>
  <div class="main">
    <div
        class="dropzone-container min-h-50px"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
    >
      <button @click.prevent="toggleFileSelector" class="btn btn-sm btn-primary">
        {{$t(title)}}
      </button>
      <br>
      <input
          type="file"
          multiple
          :id="id"
          class="d-none"
          @change="onChange"
          ref="fileInput"
          accept=".doc,.docx,.pdf,.jpg,.jpeg,.png"
      />
      <span class="form-text text-muted mt-2">{{$t('upload_text', { size, ext, number })}}</span>
      <div id="selected-files">
        <div
            v-for="(file, index) in files"
            :key="index"
            class="d-flex align-items-center justify-content-between min-h-40px w-100 bg-light-primary bg-hover-light border-hover-primary cursor-pointer px-5 rounded-2 mb-2"
        >

          <a class="text-black fw-bold d-flex align-items-center" @click.prevent="displayFile(file)"> <span v-html="getFileIcon(file, {type: 'i', size: '2.4em', className: 'me-2'})"></span> {{ displayFileName(file) }} </a>
          <span @click.prevent.exact="removeFile(index)" class="bi bi-x fs-3 cursor-pointer"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import {getFileIcon} from "@/mixins/Helpers";

const props = defineProps({
  id: { type: String, required: true },
  size: { type: String, default: '5Mo' },
  files: { type: Array, default: () => [] },
  title: { type: String, default: 'attach_file' },
  ext: { type: String, default: 'PDF, DOC, DOCX, JPEG, PNG et JPG' },
  number: {
    type: Number,
    default: 10
  }
});

const emit = defineEmits(['addFiles', 'removeFiles']);

const isDragging = ref(false);
const fileInput = ref(null);

const toggleFileSelector = () => {
  fileInput.value.click();
};

const onChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  emit('addFiles', selectedFiles);
};

const dragover = (e) => {
  e.preventDefault();
  isDragging.value = true;
};

const dragleave = () => {
  isDragging.value = false;
};

const drop = (e) => {
  e.preventDefault();
  if (!fileInput.value) {
    fileInput.value = document.querySelector('#' + props.id);
  }
  const droppedFiles = Array.from(e.dataTransfer.files);
  fileInput.value.files = e.dataTransfer.files;
  emit('addFiles', droppedFiles);
  isDragging.value = false;
};

const displayFile = (file) => {
  if (file instanceof File) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  } else {
    window.open(file.file_url, '_blank');
  }
};

const removeFile = (index) => {
  emit('removeFiles', index);
};

const displayFileName = (file) => {
  if (file instanceof File) {
    return file.name;
  } else {
    return file.file;
  }
};


</script>

<style scoped>
.dropzone-container {
  border: 1px dashed #ccc;
  border-radius: 5px;
  padding: 10px;
  transition: background-color 0.3s;
}
.dropzone-container.dragging {
  background-color: #f0f0f0;
}
.min-h-50px {
  min-height: 50px;
}
.min-h-40px {
  min-height: 40px;
}
.bg-light-primary {
  background-color: #e7f5ff;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
